import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const AdminAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [authError, setAuthError] = useState("");

  const authorizedUids = ['gQhTWaS0rDOtPTtVYciqX5g3mTE3', 'o4ltF8eOpCgEZT2g42bZPmpPxIy1'];

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // Check if user UID is in authorized list
        if (authorizedUids.includes(currentUser.uid)) {
          setAuthorized(true);
          setAuthError("");
        } else {
          setAuthorized(false);
          setAuthError("Access denied - insufficient permissions");
        }
      } else {
        setAuthorized(false);
        setAuthError("");
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-96">
        <div className="text-xl text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <AdminLogin />;
  }

  if (!authorized) {
    return (
      <div className="flex flex-col items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-4">{authError}</p>
          <p className="text-sm text-gray-500">
            Logged in as: {user.email}
          </p>
          <button
            onClick={() => getAuth().signOut()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return <AdminDashboard user={user} />;
};

export default AdminAuth;
